import { Button, Icon, Modal } from '@components';

interface DuplicateAdmissionModalProps {
  isOpen: boolean;
  admissionNumber?: string;
  isAdmissionNumberError?: boolean;
  isLoading?: boolean;
  onCancel: () => void;
  onProceed: () => void;
}

const DuplicateAdmissionModal = ({
  isOpen,
  admissionNumber,
  isAdmissionNumberError = false,
  isLoading,
  onCancel,
  onProceed
}: DuplicateAdmissionModalProps) => {
  const title = 'Member already exists!';
  const admissionNumberError = `A member with admission number ${admissionNumber} already exists. Continuing will update the existing member’s details with the new information.`;
  const memberError =
    'This member already exists. Continuing will update the existing member’s details with the new information.';
  const confirmText = 'Are you sure you want to continue?';

  return (
    <Modal isOpen={isOpen} onCancel={onCancel} className="max-w-118">
      <div className="flex flex-col items-center p-6">
        <Icon name="warning-red" size="48" className="mb-5" />
        <h2 className="text-cofeeNuetral10 mb-2 text-lg font-semibold">
          {title}
        </h2>
        <p className="text-cofeeNuetral8 text-center">
          {isAdmissionNumberError ? admissionNumberError : memberError}
        </p>
        <p className="text-cofeeNuetral8 text-center">{confirmText}</p>
        <div className="mt-6 flex w-full gap-4">
          <Button
            variant="tertiary"
            label="Cancel"
            className="w-1/2"
            handleClick={onCancel}
          />
          <Button
            label="Proceed"
            className="w-1/2"
            handleClick={onProceed}
            loading={isLoading}
          />
        </div>
      </div>
    </Modal>
  );
};

export default DuplicateAdmissionModal;
